import { customDomainsApi } from "api/TenantSlug/CustomDomain/api";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import CustomDomainData = App.Data.CustomDomainData;

export const useCustomDomainSelectOptions = () => {
    return useSelectOptions<CustomDomainData>({
        apiFunction: (payload) => customDomainsApi.index(payload),
        dataKey: "customDomains",
        cacheKey: "custom-domain-select",
        queryParams: {
            page: { number: 1, size: 100 },
            filter: { filter: {}, sort: "name" },
        },
        mapToOption: (domain) => ({
            label: domain.name,
            value: domain.id,
        }),
    });
};
